<div class="cosmic-bg" aria-hidden="true">
  <div class="nebula"></div>
  <div class="stars-sm"></div>
</div>

<mat-sidenav-container class="sidenav-container" *ngIf="(isLoading$ | async) === false; else loading">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false && (isAuthenticated$ | async)"
  >
    <app-sidebar [drawer]="drawer" [isHandset]="isHandset$ | async"></app-sidebar>
  </mat-sidenav>
  
  <mat-sidenav-content>
    <app-header
      *ngIf="isAuthenticated$ | async"
      [drawer]="drawer"
      [isHandset]="isHandset$ | async"
    ></app-header>
    
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #loading>
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
